import { useContext } from 'react';

import { SessionDataContext } from './SessionDataContext.ts';
import type { SessionDataType } from './SessionDataTypes.ts';

export const useSessionData = (): SessionDataType => useContext(SessionDataContext);
